import { SegmentSkin } from "../tail/SegmentSkin";
import type { Charge, ChargeFireContext } from "./Charge";
import { tripleBeamPattern } from "../weapons/patterns/TripleBeamPattern";

/**
 * Triple-beam laser charge.
 */
export class TripleLaserCharge implements Charge {
  readonly id = "laser.triple";
  readonly label = "Triple Beam";
  readonly skin = SegmentSkin.Star;

  fire(ctx: ChargeFireContext): void {
    tripleBeamPattern.fire(ctx);
  }
}
